import { Card, Typography, Form, Input, Select, DatePicker, Button, Row, Col, Flex, Space, Tag, Divider, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { ArrowLeftOutlined, UserOutlined } from "@ant-design/icons"
import { QuotationService } from '../../../Services/Manage/QuotationService'
import { UserService } from '../../../Services/Manage/UserService'
import { DepartmentEmpServices } from '../../../Services/Manage/DepartmentEmpServices'
import { ProjectService } from '../../../Services/Manage/ProjectService'
import useMessage from 'antd/es/message/useMessage'
import { useLocation, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const { TextArea } = Input
const { Option, OptGroup } = Select;
const { Title } = Typography;

const CreateProjects = () => {
  const [messageApi, msgContext] = useMessage();
  const [form] = Form.useForm();
  const [activeQuotation, setActiveQuotation] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [userList, setUserList] = useState([]);
  const [engineerOption, setEnginerOption] = useState([]);
  const [editProject, setEditProject] = useState(null);
  const [projectId, generateProjectId] = useState('001');
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  //edit
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const action = location.state?.action;
  const enableEdit = location.state?.enableEdit;

  useEffect(() => {
    console.log("Editing Project:", id);
    if (id) {
      getProjectDataByID(id);
      getAllUser();

    }
  }, [id])


  const getProjectDataByID = async (id) => {
    try {
      const request = await ProjectService.getAllProjectById(id);
      const initialValues = request.data;
      setEditProject(initialValues);

      if (initialValues) {
        const getUserByRole = await UserService.getUserByRole(initialValues.pro_department);


        const praseOption = getUserByRole.data.map((user) => ({
          label: user.name,
          value: user.uid,
        }));

        setEnginerOption(praseOption);
      }


      let proEngineer = initialValues.pro_engineer;
      if (typeof proEngineer === 'string') {
        try {
          proEngineer = JSON.parse(proEngineer);
        } catch (error) {
          console.error("Error parsing pro_engineer:", error);
          proEngineer = [];
        }
      }

      console.log("initialValues.pro_department", initialValues.pro_department);
      console.log("ugukjg", userList);

      setSelectedDepartment(initialValues.pro_department);
      handleGetEnginer(initialValues.pro_department);

      form.setFieldsValue({
        ...initialValues,
        pro_department: Number(initialValues.pro_department),
        pro_engineer: proEngineer,
        pro_start_date: initialValues?.pro_start_date ? dayjs(initialValues.pro_start_date, 'DD-MM-YYYY') : null,
        pro_target_end_date: initialValues?.pro_target_end_date ? dayjs(initialValues.pro_target_end_date, 'DD-MM-YYYY') : null,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const onFinish = async (values) => {
    try {
      const user = await UserService.getOmeUser();

      const payload = {
        ...values,
        pro_no: editProject ? editProject.pro_no : projectId,
        pro_engineer: JSON.stringify(values.pro_engineer || []),
        added_by: user.uid,
      };

      console.log("Form submitted:", payload);

      let request;

      if (editProject) {
        console.log("Form edittteddd:", payload);
        request = await ProjectService.updateProject(payload, id);
      } else {
        console.log("Form creattedddd:", payload);
        request = await ProjectService.createProject(payload);
      }

      if (request?.status) {
        messageApi.success(request.message);
        if (!editProject) {
          form.resetFields();
          getLastProject();
        }
      } else {
        messageApi.error(request?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error in onFinish:", error);
      messageApi.error("Unexpected error occurred");
    }
  };

  const handleDelete = async () => {
    try {
      const request = await ProjectService.deleteProject(id);
      if (request.status) {
        messageApi.success(request.message);
        navigate('/projects');
      } else {
        messageApi.error(request.message)
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllQotationProjects = async () => {
    try {
      const request = await QuotationService.getAllQotationProjects();
      setActiveQuotation(
        request.data.filter(q => q.status === 'Active' || q.status === 'active')
      );

    } catch (error) {
      console.error(error);
    }
  };

  const getAllUser = async () => {
    try {
      const request = await UserService.getAllUsers();
      console.log(request.data);

      setUserList(request.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getLastProject = async () => {
    try {
      const request = await ProjectService.getLastProject();
      const lastProject = request.data;

      let nextNo = "001";
      if (lastProject && lastProject.pro_no) {
        const current = parseInt(lastProject.pro_no, 10);
        if (!isNaN(current)) {
          nextNo = String(current + 1);
          if (current + 1 < 1000) {
            nextNo = nextNo.padStart(3, "0");
          }
        }
      }
      generateProjectId(nextNo);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const request = await DepartmentEmpServices.getAllDepartment();
      const option = request.data.map((item) => ({
        value: item.id,
        label: item.name
      }));
      setDepartmentOption(option);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllQotationProjects();
    getLastProject();
    getAllDepartment();
    getAllUser();
  }, []);

  const handleGetEnginer = async (value) => {
    console.log("handleGetEnginer", value);

    setSelectedDepartment(value);

    const getUserByRole = await UserService.getUserByRole(value);


    const praseOption = getUserByRole.data.map((user) => ({
      label: user.name,
      value: user.uid,
    }));

    console.log('getUserByRole', praseOption);

    setEnginerOption(praseOption);

  };

  const renderItem = (eqId, customer_name) => (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <span>{eqId}</span>
      <span>
        <UserOutlined /> {customer_name}
      </span>
    </Flex>
  );

  const grouped = activeQuotation.reduce((acc, item) => {
    if (!acc[item.service_id]) {
      acc[item.service_id] = {
        service_name: item.service_name,
        items: [],
      };
    }
    acc[item.service_id].items.push(item);
    return acc;
  }, {});

  return (
    <>
      {msgContext}
      <Card
        title={
          <Space align="center">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ArrowLeftOutlined
                style={{ cursor: "pointer", fontSize: "20px" }}
                onClick={() => 
                  // window.history.back()
                  navigate('/projects')
                }
              />
              <Title level={4} style={{ margin: 0 }}>
                <Space>
                  {editProject ? `${action} Project` : 'Create Project'}{' '}
                  {editProject ? (
                    <Tag
                      color="cyan"
                      style={{
                        fontSize: '16px',
                        padding: '6px 16px',
                        borderRadius: '8px',
                        fontWeight: 600,
                      }}
                    >
                      Project ID: {editProject.pro_no}
                    </Tag>
                  ) : (
                    projectId && (
                      <Tag
                        color="blue"
                        style={{
                          fontSize: '16px',
                          padding: '6px 16px',
                          borderRadius: '8px',
                          fontWeight: 600,
                        }}
                      >
                        Project ID: {projectId}
                      </Tag>
                    )
                  )}
                </Space>
              </Title>
            </div>
          </Space>
        }
        extra={<>
          {!enableEdit && (

            <Button size="large" danger onClick={() => navigate("/projects/edit", { state: { id: id, action: 'Edit', enableEdit: true } })}>
              Enable Edit
            </Button>

          )}
        </>
        }
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Row gutter={[16, 16]} style={{ padding: '50px 50px 0 50px' }}>
            {/* Quotation */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="qu_no" label="Select Quotation" rules={[{ required: true }]}>
                <Select
                  showSearch
                  allowClear
                  placeholder="Select approved enquiry"
                  size="large"
                >
                  {Object.values(grouped).map((group) => (
                    <OptGroup key={group.service_name} label={group.service_name}>
                      {group.items.map((item) => (
                        <Option key={item.qu_no} value={item.qu_no}>
                          {renderItem(item.qu_no, item.customer_name)}
                        </Option>
                      ))}
                    </OptGroup>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Project Name */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_name" label="Project Name" rules={[{ required: true }]}>
                <Input size="large" placeholder="Enter Project Name" />
              </Form.Item>
            </Col>

            {/* Description */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_description" label="Project Description">
                <TextArea size="large" rows={2} placeholder="Enter Description" />
              </Form.Item>
            </Col>

            {/* Department - FIXED */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_department" label="Select Department">
                <Select size="large"
                  allowClear
                  optionFilterProp="label"
                  showSearch
                  placeholder="Select Department"
                  options={departmentOption}
                  onChange={handleGetEnginer}
                />
              </Form.Item>
            </Col>

            {/* Engineer */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_engineer" label="Engineer">
                <Select size="large"
                  mode="multiple"
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={engineerOption}
                  placeholder="Select Engineers"
                  disabled={!selectedDepartment}
                />
              </Form.Item>
            </Col>

            {/* Start Date */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_start_date" label="Start Date">
                <DatePicker size="large" style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            {/* Target End Date */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_target_end_date" label="Target End Date">
                <DatePicker size="large" style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            {/* Requirements */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_requirements" label="Requirements">
                <TextArea size="large" rows={2} placeholder="Enter Requirements" />
              </Form.Item>
            </Col>

            {/* Status */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_status" label="Status">
                <Select placeholder="Select Status" size="large">
                  <Option value="Live">Live</Option>
                  <Option value="Hold">Hold</Option>
                  <Option value="Pending">Pending</Option>
                  <Option value="Archive">Archive</Option>
                  <Option value="Completed">Completed</Option>
                </Select>
              </Form.Item>
            </Col>

            {/* Comment */}
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="pro_comment" label="Comment">
                <TextArea size="large" rows={2} placeholder="Enter Comments" />
              </Form.Item>
            </Col>

          </Row>
          <Divider />
          {enableEdit && (

            
          
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Space>

              <Button size='large' onClick={() => window.history.back()} >Back</Button>

              {editProject && (

                <Button  size="large" danger onClick={handleDelete}>
                  Delete Project
                </Button>

              )}


              <Button  type="primary" size="large" htmlType="submit">
                {editProject ? "Update Project" : "Create Project"}
              </Button>
            </Space>
          </div>

          )}
        </Form>
      </Card>
    </>
  );
};

export default CreateProjects;